import { render, staticRenderFns } from "./SendFile.vue?vue&type=template&id=098b6a7a"
import script from "./SendFile.vue?vue&type=script&lang=js"
export * from "./SendFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports